export const enum dashboardConstants {
  // Common Reports
  getCommonReportsRequest = "GET_COMMON_REPORTS_REQUEST",
  getCommonReportsSuccess = "GET_COMMON_REPORTS_SUCCESS",
  getCommonReportsFailure = "GET_COMMON_REPORTS_FAILURE",

  // Revenue Report
  getRevenueReportRequest = "GET_REVENUE_REPORT_REQUEST",
  getRevenueReportSuccess = "GET_REVENUE_REPORT_SUCCESS",
  getRevenueReportFailure = "GET_REVENUE_REPORT_FAILURE",

  // Student Report
  getStudentReportRequest = "GET_STUDENT_REPORT_REQUEST",
  getStudentReportSuccess = "GET_STUDENT_REPORT_SUCCESS",
  getStudentReportFailure = "GET_STUDENT_REPORT_FAILURE",

  // Instructor Report
  getInstructorReportRequest = "GET_INSTRUCTOR_REPORT_REQUEST",
  getInstructorReportSuccess = "GET_INSTRUCTOR_REPORT_SUCCESS",
  getInstructorReportFailure = "GET_INSTRUCTOR_REPORT_FAILURE",
}
